import { call, put, takeLatest } from 'redux-saga/effects';
import apiCall from '../helpers/ApiCall';
import apiRoot from '../consts/apiRoot';
import { CREATE_AD, CREATE_AD_FAIL, CREATE_AD_SUCCESS } from '../redux/Ads';
import { POST } from '../consts/Methods';
import { SET_LOADER } from '../redux/Loader';

function* createNewAdFlow({ payload, }) {
  try {
    const { highlight_1, highlight_2, ...otherParams } = payload;
    const highlights = [highlight_1, highlight_2];
    const params = { highlights, ...otherParams, };
    const endpoint = `${apiRoot}/ads`;
    yield put(SET_LOADER({ value: true, }));
    const response = yield call(apiCall, { method: POST, endpoint, params: { ad: params, }, });
    yield put(CREATE_AD_SUCCESS(response));
  } catch (error) {
    yield put(CREATE_AD_FAIL(error));
  } finally {
    yield put(SET_LOADER({ value: false, }));
  }
}

export default function* CreateNewAd() {
  yield takeLatest(CREATE_AD, createNewAdFlow);
}
